import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import withRouter from "../../components/Common/withRouter";
import {Col, Row, Label, Button, Card, CardBody, Form} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {getAdmins, getAWBes, getCompanies, getLogistics} from "../../store/actions";

import WaitingColumns from "./WaitingColumns";
import TariffIssuedColumns from "./TariffIssuedColumns";
import ConfirmedColumns from "./ConfirmedColumns";
import StockColumns from "./StockColumns";
import RejectColumns from "./RejectColumns";
import DomesticShippingColumns from "./DomesticShippingColumns";
import OrganizeLoadColumns from "./OrganizeLoadColumns";
import InstructionColumns from "./InstructionColumns";
import ArchiveColumns from "./ArchiveColumns";
import DeclarationColumns from "./DeclarationColumns";
import CourierColumns from "./CourierColumns";

import Preloader from "../../components/Preloader/Preloader";
import Error from "../../components/Error/Error";
import Nulled from "../../components/Null/Nulled";
import {useParams} from "react-router-dom";
import Select from "react-select";

const TYPE_OPTIONS = [
    {value: "", label: "ყველა ტიპი"}, // All
    {value: "aer", label: "საჰაერო"},
    {value: "sea", label: "საზღვაო"},
    {value: "land", label: "სახმელეთო"},
    // добавь свои реальные значения (как в базе)
];


const Lists = (props) => {
    const dispatch = useDispatch();
    const {status} = useParams();

    const isLoading = useSelector((state) => state.Logistic.isLoading);
    const error = useSelector((state) => state.Logistic.error);
    const array = useSelector((state) => state.Logistic.array);

    // ВАЖНО: добавь это в reducer: state.Logistic.resultCount
    const resultCount = useSelector((state) => state.Logistic.arrayCount || 0);

    const [breadcrumbs, setBreadcrumbs] = useState("");

    // пагинация
    const [skip, setSkip] = useState(0);
    const [limit, setLimit] = useState(5);

    const page = useMemo(() => Math.floor(skip / limit) + 1, [skip, limit]);


    const admins = useSelector((state) => state.Admin?.array || []); // поправь reducer если другой
    const companies = useSelector((state) => state.Company?.array || []); // поправь reducer если другой

    const sellers = useMemo(
        () => admins.filter((a) => a?.role === "sell"),
        [admins]
    );

    const logisticsUsers = useMemo(
        () => admins.filter((a) => a?.role === "logistic"),
        [admins]
    );

// ----- filters: draft (UI) + applied (used on Search) -----
    const [filtersDraft, setFiltersDraft] = useState({
        companyId: "",
        sellerId: "",
        logisticId: "",
        type: "",
    });

    const [filtersApplied, setFiltersApplied] = useState({
        companyId: "",
        sellerId: "",
        logisticId: "",
        type: "",
    });


    const totalPages = useMemo(() => {
        if (!resultCount) return 1;
        return Math.max(1, Math.ceil(resultCount / limit));
    }, [resultCount, limit]);

    const fetchPage = (nextSkip, nextLimit = limit, filters = filtersApplied) => {
        const item = {
            status,
            skip: nextSkip,
            limit: nextLimit,
            query: buildFiltersQuery(filters), // 👈 добавили
        };

        dispatch(getLogistics(item));
    };

    useEffect(() => {
        dispatch(getCompanies({skip: 0, limit: 10000}));
    }, [dispatch]);

    // при смене статуса — сбрасываем на 1 страницу
    useEffect(() => {
        setSkip(0);
        fetchPage(0, limit);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status]);

    // если меняем limit — тоже сброс на 1 страницу
    useEffect(() => {
        setSkip(0);
        fetchPage(0, limit);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [limit]);

    useEffect(() => {
        if (status === "waiting") setBreadcrumbs("მოლოდინის რეჟიმი");
        else if (status === "tariffIssued") setBreadcrumbs("ტარიფი გაცემულია");
        else if (status === "confirmed") setBreadcrumbs("დადასტურდა");
        else if (status === "reject") setBreadcrumbs("უარი");
        else if (status === "organizeLoad") setBreadcrumbs("ტვირთის ორგანიზება");
        else if (status === "domesticShipping") setBreadcrumbs("შიდა გადაზიდვა");
        else if (status === "stock") setBreadcrumbs("საწყობშია");
        else if (status === "instruction") setBreadcrumbs("ინსტრუქცია");
        else if (status === "AWB") setBreadcrumbs("AWB");
        else if (status === "declaration") setBreadcrumbs("დეკლარაცია");
        else if (status === "courier") setBreadcrumbs("საკურიერო");
        else if (status === "archive") setBreadcrumbs("არქივი");
    }, [status]);

    useEffect(() => {
        dispatch(getAdmins());
        dispatch(getAWBes({skip: 0, limit: 10000, status: "active"}));
    }, [dispatch]);

    // handlers
    const onPrev = () => {
        const nextSkip = Math.max(0, skip - limit);
        setSkip(nextSkip);
        fetchPage(nextSkip, limit); // uses filtersApplied
    };

    const onNext = () => {
        const nextSkip = skip + limit;
        if (resultCount && nextSkip >= resultCount) return;

        setSkip(nextSkip);
        fetchPage(nextSkip, limit); // uses filtersApplied
    };


    const canPrev = skip > 0;
    const canNext = resultCount ? skip + limit < resultCount : array.length === limit;

    const commonProps = {
        status,
        array,
        // pagination props
        pagination: {
            skip,
            limit,
            page,
            totalPages,
            resultCount,
            canPrev,
            canNext,
            onPrev,
            onNext,
            setLimit, // чтобы менять limit из таблицы
        },
    };


    const onChangeFilter = (key) => (e) => {
        console.log("%%%", e)
        const val = e.target.value;
        setFiltersDraft((p) => ({...p, [key]: val}));
    };

    const onResetFilters = () => {
        const clean = {companyId: "", sellerId: "", logisticId: "", type: ""};
        setFiltersDraft(clean);
        setFiltersApplied(clean);
        // после reset — грузим 1 страницу без фильтров
        setSkip(0);
        fetchPage(0, limit);
    };

    const onSearch = () => {
        const nextFilters = {...filtersDraft};

        setFiltersApplied(nextFilters);
        setSkip(0);

        // ВАЖНО: передаём nextFilters напрямую
        fetchPage(0, limit, nextFilters);
    };


    function buildFiltersQuery(filters) {
        const qs = new URLSearchParams();

        if (filters.companyId) qs.set("companyId", filters.companyId);
        if (filters.sellerId) qs.set("sellerId", filters.sellerId);
        if (filters.logisticId) qs.set("logisticId", filters.logisticId);
        if (filters.type) qs.set("type", filters.type);

        const s = qs.toString();
        return s ? `?${s}` : "";
    }


    const companyOptions = useMemo(() => {
        const arr = Array.isArray(companies) ? companies : [];
        return [
            {value: "", label: "ყველა კომპანია"},
            ...arr.map((c) => ({
                value: String(c._id),
                label: c.companyName || c.name || c.title || String(c._id),
            })),
        ];
    }, [companies]);

    const selectedCompany = useMemo(() => {
        return (
            companyOptions.find((opt) => opt.value === filtersDraft.companyId) || null
        );
    }, [companyOptions, filtersDraft.companyId]);

    const onCompanySelect = (option) => {
        setFiltersDraft((p) => ({...p, companyId: option?.value || ""}));
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs
                        title={process.env.REACT_APP_PROJECT_NAME}
                        breadcrumbItem={breadcrumbs}
                    />

                    {isLoading ? (
                        <Preloader/>
                    ) : error ? (
                        <Error/>
                    ) : (
                        <Row>
                            <Card className="mb-3">
                                <CardBody>
                                    <Row className="g-3 align-items-end">

                                        {/* 1) Company */}


                                        {/* 2) Seller */}
                                        <Col md={3}>
                                            <Label className="form-label">გაყიდვები (Seller)</Label>
                                            <Select
                                                value={selectedCompany}
                                                onChange={onCompanySelect}
                                                options={companyOptions}
                                                placeholder="აირჩიეთ კომპანია"
                                                classNamePrefix="rs"   // важно: НЕ form-select
                                                isClearable
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Label className="form-label">გაყიდვები (Seller)</Label>
                                            <select
                                                className="form-select"
                                                value={filtersDraft.sellerId}
                                                onChange={onChangeFilter("sellerId")}
                                            >
                                                <option value="">ყველა</option>
                                                {sellers.map((a) => (
                                                    <option key={String(a._id)} value={String(a._id)}>
                                                        {a.name || a.email || String(a._id)}
                                                    </option>
                                                ))}
                                            </select>
                                        </Col>

                                        {/* 3) Logistic */}
                                        <Col md={3}>
                                            <Label className="form-label">ლოგისტიკა (Logistic)</Label>
                                            <select
                                                className="form-select"
                                                value={filtersDraft.logisticId}
                                                onChange={onChangeFilter("logisticId")}
                                            >
                                                <option value="">ყველა</option>
                                                {logisticsUsers.map((a) => (
                                                    <option key={String(a._id)} value={String(a._id)}>
                                                        {a.name || a.email || String(a._id)}
                                                    </option>
                                                ))}
                                            </select>
                                        </Col>

                                        {/* 4) Type (static) */}
                                        <Col md={2}>
                                            <Label className="form-label">ტიპი</Label>
                                            <select
                                                className="form-select"
                                                value={filtersDraft.type}
                                                onChange={onChangeFilter("type")}
                                            >
                                                {TYPE_OPTIONS.map((t) => (
                                                    <option key={t.value || "ALL"} value={t.value}>
                                                        {t.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </Col>

                                        {/* Actions */}
                                        <Col md={1} className="d-grid">
                                            <Button color="primary" onClick={onSearch}>
                                                Search
                                            </Button>
                                            <Button color="light" className="mt-2" onClick={onResetFilters}>
                                                Reset
                                            </Button>
                                        </Col>

                                    </Row>
                                </CardBody>
                            </Card>


                            {array.length > 0 ? (
                                <Col lg={12} style={{overflowX: "auto"}}>
                                    {status === "waiting" && <WaitingColumns {...commonProps} />}

                                    {status === "tariffIssued" && (
                                        <TariffIssuedColumns {...commonProps} />
                                    )}

                                    {status === "confirmed" && (
                                        <ConfirmedColumns {...commonProps} />
                                    )}

                                    {(status === "AWB" || status === "stock") && (
                                        <StockColumns {...commonProps} />
                                    )}

                                    {status === "reject" && <RejectColumns {...commonProps} />}

                                    {status === "domesticShipping" && (
                                        <DomesticShippingColumns {...commonProps} />
                                    )}

                                    {status === "organizeLoad" && (
                                        <OrganizeLoadColumns {...commonProps} />
                                    )}

                                    {status === "instruction" && (
                                        <InstructionColumns {...commonProps} />
                                    )}

                                    {status === "archive" && <ArchiveColumns {...commonProps} />}

                                    {status === "declaration" && (
                                        <DeclarationColumns {...commonProps} />
                                    )}

                                    {status === "courier" && <CourierColumns {...commonProps} />}
                                </Col>
                            ) : (
                                <Nulled/>
                            )}
                        </Row>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default withRouter(Lists);
